export default {
  // 数据上报sdk
  report: {
    name: 'VhallReport',
    url: '//cnstatic01.e.vhall.com/common-static/middle/middle-log/1.0.7/index.min.js'
  },
  // dataAgent: {
  //   name: 'VhallAgentReport',
  //   url: '//static.vhallyun.com/jssdk/vhall-jssdk-dataagent/1.1.0/vhall-jssdk-dataagent-1.1.0.js'
  // }
};